<template>
  <v-card :flat="flat">
    <v-card-title v-if="!flat" style="height: 80px" class="py-0 my-0">
      <slot name="title">
        <span v-if="data.name" class="title pl-2">{{data.name}}</span>
        <span v-else class="title pl-2 grey--text">{{placeholder}}</span>
        <v-spacer></v-spacer>
        <v-btn v-if="!expand" @click="expand_ = !expand_" flat color="primary" class="mr-0">{{expand_ ? '收起':'展开'}}</v-btn>
        <v-btn color="primary" @click="goDetails" flat :disabled="person.loginId==''">查看详情</v-btn>
      </slot>
    </v-card-title>
    <v-card-text :class="flat ? 'pa-0':''">
      <v-container grid-list-md fluid class="py-0" :class="flat ? 'px-0': ''">
        <v-subheader v-if="subheader">{{subheader}}
          <v-btn v-if="!expand" @click="expand_ = !expand_" flat color="primary" class="mr-0">{{expand_ ? '收起':'展开'}}</v-btn>
          <slot name="subheader-action"></slot>
          <v-btn color="primary" @click="goDetails" flat :disabled="person.loginId==''">查看详情</v-btn>
        </v-subheader>
        <v-expand-transition>
          <v-layout v-if="expand_ || expand" wrap>
            <v-flex :key="i" v-for="(opt,i) in opts" :class="opt.layout">
              <info-cell v-bind="opt" v-model="data[opt.key]"></info-cell>
            </v-flex>
          </v-layout>
        </v-expand-transition>
        <v-expand-transition>
          <v-layout wrap v-if="!(expand_ || expand)">
            <v-flex :key="i" v-for="(opt,i) in optsLite" :class="opt.layout">
              <info-cell v-bind="opt" v-model="data[opt.key]"></info-cell>
            </v-flex>
          </v-layout>
        </v-expand-transition>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {Person} from '../object'
import InfoCell from './infoCell'
import {ID_TYPE_TEXT} from '../consts/reservation'

export default {
  name: 'personInfoCard',
  components: {InfoCell},
  props: {
    subheader: {type: String, default: ''},
    flat: {type: Boolean, default: false},
    person: {required: true},
    expand: {type: Boolean, default: false},
    placeholder: {type: String, default: '用户姓名'},
    type:{type:String,default:''},
  },
  computed:{
    optsLite(){
      return [
        {
          key: 'name',
          label: '用户姓名',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.person',
        },
        {
          key: 'phone',
          label: '电话号码',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.phone',
        },
        {
          key: 'orgName',
          label:(this.type==='personReservation')?'单位|车牌':'所在单位',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.org',
        },
      ]
    },
    opts(){
      return [
        {
          key: 'name',
          label: '用户姓名',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.person',
        },
        {
          key: 'loginId',
          label: '用户账号',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.loginId',
        },
        {
          key: 'phone',
          label: '电话号码',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.phone',
        },
        {
          key: 'email',
          label: '电子邮箱',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.email',
        },
        {
          key: 'idType',
          label: '证件类型',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.idCardType',
          f: v => ID_TYPE_TEXT[v] || v,
        },
        {
          key: 'idNumber',
          label: '证件号码',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.idCard',
        },
        {
          key: 'orgName',
          label:(this.type==='personReservation')?'单位|车牌':'所在单位',
          layout: ['xs12 sm8'],
          icon: '$vuetify.icons.org',
        },
        {
          key: 'typeName',
          label: '登记类型',
          layout: ['xs12 sm4'],
          icon: '$vuetify.icons.group',
        },
      ]
    },
    data () {
      return this.person instanceof Object ? this.person : new Person()
    },
  },
  data: () => ({
    expand_: false,
  }),
  created(){
    console.log(this.person)
  },
  methods:{
    goDetails(){
      this.$router.push({
        name: 'UserDetails',
        params:{loginId:this.person.loginId},
        query: {id: this.person.loginId,from:'other'}
      })
    }
  }
}
</script>

<style scoped>

</style>
